// extracted by mini-css-extract-plugin
export default {"micro-fe-popup":"micro-fe-popup_micro-fe-popup__Gindf","microFePopup":"micro-fe-popup_micro-fe-popup__Gindf"};